module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"disable":"Disable"}}')
  delete Component.options._Ctor
}
